import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { GlobalLoaderComponent } from '@ls/ui-loader';

@Component({
  imports: [RouterModule, GlobalLoaderComponent],
  selector: 'le-root',
  templateUrl: './app.html',
  styleUrl: './app.scss',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class App {
  protected title = 'Instant Checkout Lifewave';

  private readonly matIconRegistry = inject(MatIconRegistry);

  constructor() {
    this.matIconRegistry.setDefaultFontSetClass('material-symbols-rounded');
  }
}
